import { useState, useEffect } from 'react'
import { createClient } from '@sanity/client'
import { fetchFAQData } from '../../api'
import { toast } from 'react-toastify'
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'
import COPY from '../../utils/copy'
import '../../accordion.css'
import { ReactNode } from 'react'

type AccordionItemHeadingProps = {
  tag?: keyof JSX.IntrinsicElements
  children: ReactNode
}

const AccordionItemHeading = ({ tag = 'div', children }: AccordionItemHeadingProps) => {
  const HeadingTag = tag
  return <HeadingTag className='accordion__heading'>{children}</HeadingTag>
}

export default function FrequentlyAskedQuestions() {
  const [isLoading, setIsLoading] = useState(true)
  const [FAQData, setFAQData] = useState<{ _id: string; question: string; answer: string }[]>([])

  useEffect(() => {
    const client = createClient({
      projectId: COPY.SANITY_PROJECT_ID,
      dataset: COPY.SANITY_DATASET,
      apiVersion: COPY.SANITY_API_VERSION,
      useCdn: true,
    })

    client
      .fetch(fetchFAQData)
      .then((data) => {
        setFAQData(data)
      })
      .catch((error) =>
        toast.error(error, {
          position: 'bottom-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        }),
      )
    setIsLoading(false)
  }, [])

  return (
    <section
      id={COPY.FAQ_ID}
      className='h-100% w-screen p-6 sm:p-24 bg-gray-50 flex flex-col justify-center items-center'
    >
      <p className='text-3xl sm:text-5xl text-black font-black mb-6 sm:mb-12 text-center'>
        {COPY.FAQ_HEADER}
      </p>
      {isLoading ? (
        <p className='text-black font-medium tracking-wide text-lg'>{COPY.LOADING}</p>
      ) : (
        <Accordion allowZeroExpanded={true} className='xl:w-1/2'>
          {FAQData.map((question) => (
            <AccordionItem key={question._id} uuid={question._id}>
              <AccordionItemHeading tag='h2'>
                <AccordionItemButton>{question.question}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>{question.answer}</AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>
      )}
    </section>
  )
}
